import React, { ReactNode } from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { IBaseProps } from '@rbi-ctg/frontend';
import { Box, BoxProps } from 'components/ui';

import theme from '../theme';

type IModalContentProps = IBaseProps &
  Omit<BoxProps, 'children'> & {
    bgColor?: string;
    disableFooter?: boolean;
    expand?: boolean;
    overScrollerContent?: ReactNode;
  };

interface IInner extends IBaseProps {
  expand?: boolean;
}

const ModalWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.modalWrapper, style]} />
);

const Inner = ({ expand, style, ...props }: IInner & BoxProps) => (
  <Box {...props} style={[styles.inner, expand && styles.expandedInner, style]} />
);

const Scroller = ScrollView.withConfig({
  paddingTop: {
    base: '$16',
    md: '$20',
  },
});

const ModalContent = ({
  children,
  bgColor = theme.modalWrapperBackground,
  expand = false,
  overScrollerContent,
  style,
  ...rest
}: IModalContentProps) => {
  return (
    <ModalWrapper accessibilityViewIsModal style={[{ backgroundColor: bgColor }, style]} {...rest}>
      {overScrollerContent && <Box style={styles.overScrollerContent}>{overScrollerContent}</Box>}
      <Scroller>
        <Box style={styles.scrollerContent}>
          <Inner expand={expand}>{children}</Inner>
        </Box>
      </Scroller>
    </ModalWrapper>
  );
};

export default ModalContent;

const styles = StyleSheet.create({
  modalWrapper: { height: '100%', width: '100%' },
  inner: { alignItems: 'center', alignSelf: 'center', maxWidth: 710, width: '100%' },
  expandedInner: { height: '95%' },
  overScrollerContent: { zIndex: 2 },
  scrollerContent: { height: '100%', padding: 32 },
});
